<template>
  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      :id="id"
      :checked="value"
      @input="updateInput"
      :disabled="disabled"
    />
    <label class="form-check-label" :for="id">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      Type: String,
      Required: true,
    },
    disabled: {
      Type: Boolean,
      Required: false,
      Default: false,
    },
    value: {
      Type: Boolean,
      Required: true,
    },
  },
  methods: {
    updateInput() {
      this.$emit("input", !this.value);
    },
  },
};
</script>
